import Api from '@services/API';

/**
 * @typedef {XGrowWithdrawService}
 */
export default class XGrowWithdrawService extends Api {
  /**
   * @type {String}
   */
  static base = '/api'
  static resource = '/integration/xgrow/withdrawal'

  constructor(resource = XGrowWithdrawService.resource, options = {}, http = null) {
    super(XGrowWithdrawService.normalize(XGrowWithdrawService.base, resource), options, http)
  }

  static build() {
    return new this()
  }
}